import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { TrackerListView } from '@/features/tracker/TrackerListView'
import { AdminGuard } from '@/components/admin-guard'

function AdminTracker() {
  const { company } = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })
  return (
    <AdminGuard>
      <TrackerListView
        admin
        companyId={company}
        onCompanyChange={id => navigate({ search: { company: id || undefined }, replace: true })}
      />
    </AdminGuard>
  )
}

export const Route = createFileRoute('/admin/tracker')({
  validateSearch: (raw: Record<string, unknown>): { company?: string } => ({
    company: typeof raw.company === 'string' && raw.company ? raw.company : undefined,
  }),
  component: AdminTracker,
})
